import { render } from "./MainProductsUnitMeasure.vue?vue&type=template&id=7bdcc7de"
import script from "./MainProductsUnitMeasure.vue?vue&type=script&lang=js"
export * from "./MainProductsUnitMeasure.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__